module.exports = __webpack_public_path__ + "static/media/retrato_4.23f89ab1.jpg";